import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconArrowRight: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="14" viewBox="0 0 20 14" width="20" {...props}>
        <path
            d="M19.728 6.342L13.776.391a.93.93 0 00-1.315 1.315l4.364 4.364H.93a.93.93 0 000 1.86h15.895l-4.364 4.364a.93.93 0 101.315 1.315l5.952-5.951a.93.93 0 000-1.316z"
            fill="currentColor"
        />
    </svg>
);
